<div class="countrynewsitem__wrapper">
  <a class="countrynewsitem__title" href="{{ item?.link }}" target="_blank">{{ item?.title }}</a>
  <div class="countrynewsitem__description">{{ item?.description }}</div>
  <div class="countrynewsitem__date">{{ item?.pubDate }}</div>
</div>
